module.exports = __webpack_public_path__ + "static/media/16.0af948e2.jpg";